/**
 * Rider Withdrawal & Payment Provider Helpers
 */

export async function calculateFee(amount) {
  try {
    const feeUrl =
      'https://api.monrapidoo.com/settings/byKey?group=ultraxeno&key=fees&service=rapidoo'
    const res = await fetch(feeUrl)

    if (!res.ok) {
      return null
    }

    const responseData = await res.json()

    if (responseData?.statusCode !== 200 || !responseData?.data?.payoutRider && !responseData?.data?.payout) {
      return null
    }

    const payout = responseData.data.payoutRider || responseData.data.payout
    const feePercent = payout.percent ?? 0
    const feeFix = payout.fixedFee ?? 0
    const applyFeeOnSrc = payout.applyFeeOnSrc ?? false

    const feePercentCalculated = (amount * feePercent) / 100
    const totalFeeCalculated = feePercentCalculated + feeFix

    const srcAmount = applyFeeOnSrc ? amount + totalFeeCalculated : amount
    const dstAmount = !applyFeeOnSrc ? amount - totalFeeCalculated : amount

    return {
      srcAmount,
      dstAmount,
      totalFeeCalculated,
      feePercent,
      feeFix,
      feePercentCalculated,
      applyFeeOnSrc,
    }
  } catch (error) {
    console.error('Erreur lors du calcul des frais :', error)
    return null
  }
}

export async function getProviderToUse(isCollect) {
  try {
    const feeUrl =
      'https://api.monrapidoo.com/settings/byKey?group=ultraxeno&key=fees&service=rapidoo'
    const res = await fetch(feeUrl)

    if (!res.ok) {
      return null
    }

    const responseData = await res.json()

    if (
      responseData?.statusCode !== 200 ||
      !responseData?.data?.paymentProviders
    ) {
      return null
    }

    const collectionProviders =
      responseData.data.paymentProviders.collectionProviders
    const withdrawalProviders =
      responseData.data.paymentProviders.withdrawalProviders

    if (isCollect) {
      return collectionProviders
    } else {
      return withdrawalProviders
    }
  } catch (error) {
    console.error(
      'Erreur lors de la récupération du fournisseur de paiement :',
      error,
    )
    return null
  }
}

export async function checkFedapayAccount(phoneNumber, operator = 'mtn') {
  try {
    let cleanPhone = String(phoneNumber || '')
      .replace(/\+/g, '')
      .replace(/\s+/g, '')
      .trim()
    if (cleanPhone.startsWith('229') && cleanPhone.length > 8) {
      cleanPhone = cleanPhone.slice(3)
    }
    const cleanOp = (operator || 'mtn').toLowerCase()
    const url = `https://api.monrapidoo.com/fedapay-pilot/account/check?phoneNumber=${cleanPhone}&operator=${cleanOp}&group=ultraxeno`
    const res = await fetch(url)
    if (!res.ok) {
      return { exists: false, isVerified: false, hasError: true }
    }
    const json = await res.json()
    const data = json?.data || {}
    return {
      exists: !!data?.exists,
      isVerified: !!data?.isVerified,
      status: data?.status || '',
      hasError: !!data?.hasError,
      data: data,
    }
  } catch (error) {
    console.error('Erreur lors de la vérification du compte :', error)
    return { exists: false, isVerified: false, hasError: true, error }
  }
}

export async function getPayoutLimit(platform = 'rider') {
  try {
    const feeUrl =
      'https://api.monrapidoo.com/settings/byKey?group=ultraxeno&key=fees&service=rapidoo'
    const res = await fetch(feeUrl)

    if (!res.ok) {
      return { min: 1000, max: 10000 }
    }

    const responseData = await res.json()

    if (responseData?.statusCode !== 200 || !responseData?.data?.amountLimits) {
      return { min: 1000, max: 10000 }
    }

    const limits = responseData.data.amountLimits
    const normalizedPlatform = (platform || '').toLowerCase()

    let payoutLimit = null
    if (normalizedPlatform === 'rider' || normalizedPlatform === 'payoutrider') {
      payoutLimit = limits.payoutRider || limits.payout
    } else if (
      normalizedPlatform === 'restaurant' ||
      normalizedPlatform === 'payoutrestaurant' ||
      normalizedPlatform === 'merchant'
    ) {
      payoutLimit = limits.payoutRestaurant || limits.payout
    } else {
      payoutLimit = limits.payout
    }

    return {
      min: payoutLimit?.min ?? 1000,
      max: payoutLimit?.max ?? 10000,
      rawLimits: limits,
    }
  } catch (error) {
    console.error('Erreur lors de la récupération des limites de retrait :', error)
    return { min: 1000, max: 10000 }
  }
}
